import { createContext } from "react";

export let PrivacyPolicyContext = createContext(null)

